angular.module('bmsApp.settings')
	.factory('DisclaimerTextSvc',
		function (
			CRUDSvc, DISCLAIMER_TEXT_API) {
		return {
			read: function () {return CRUDSvc.get(DISCLAIMER_TEXT_API.READ);},
			save: function (data) {return CRUDSvc.post(DISCLAIMER_TEXT_API.SAVE, data);},

		};
	})
	.constant('DISCLAIMER_TEXT_API', {
	READ: 'api/settings/disclaimer-text/read',
	SAVE: 'api/settings/disclaimer-text/save',
});
